import React from 'react';
import * as api from '../../../api';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import CandidaturePreview from './CandidaturePreview';
import CompanyMoreInformation from './CompanyMoreInformation';
import CandidatureForm from './CandidatureForm';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import styled from 'styled-components';
import Section from '../../Atoms/Section';

const CompanyContainer = styled.div`
    margin: 10px 0;
    padding : 10px;
    background-color: white;
    position: relative;

    & > img {
        max-width: 120px;
        max-height: 120px;
        position:absolute;
        top:10px;
        right:10px;
    }

    & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    & > div > button {
        max-width: 200px;
    }

    & .newtag {
        position: absolute;
        top: 0;
        right: 0;
        color: white;
        background-color: #46d84c;
        border-radius: 0 0 0 10px;
        font-weight: 200;
        font-size: 10px;
        padding: 5px;
    }
`

const DisbaledButton = styled.button`
    background-color: #F6F6F6;
    color: #BDBDBD;
    border: 1px solid #BDBDBD;
    cursor: not-allowed;
    &:hover {
        background-color: #F6F6F6;
        color: #BDBDBD;
        border: 1px solid #BDBDBD;
        filter: none;
    }
`

const Candidatures = (props) => {

    const { i18n } = useTranslation('common');

    const [candidatures, setCandidatures] = React.useState([]);
    const [participatingCompanies, setParticipatingCompanies] = React.useState([]);

    const [selectedCompany, setSelectedCompany] = React.useState(null);
    const [candidating, setCandidating] = React.useState(false);
    const [candidaturesValidity, setCandidaturesValidity] = React.useState(false);
    const [candidaturesUpdated, setCandidaturesUpdated] = React.useState(false);

    // get event
    React.useEffect(() => {
        if(!props.event) return;
        api.getParticipatingUsersWithData({eventId : props.event._id}).then((response) => {
            console.log("response.data of getParticipatingUsersWithData")
            console.log(response.data)
            setParticipatingCompanies(response.data.filter((participation) => participation.participation.type[3] === "a").filter((participation) => participation.participation.data?.entreprise_validee));
        }).catch((error) => {
            console.log(error);
        });
    },[props.event]);

    // get candidatures
    React.useEffect(() => {
        if(!props.user || participatingCompanies.length === 0) return;
        getCandidatures();
    },[props.user,participatingCompanies]);
    function getCandidatures(){
        api.GetUserCandidatures({userId:props.user._id}).then((response) => {
            setCandidatures(response.data.filter((candidature) => participatingCompanies.find((participation) => participation.participation._id === candidature.participationId)));
            console.log(response.data)
        }).catch((error) => {
            console.log(error);
        });
    }

    //update candidatures validity
    React.useEffect(() => {
        let priorities = [];
        for(let i=0;i<candidatures.length;i++){
            if(candidatures[i].priorite === ""){
                setCandidaturesValidity(false);
                return;
            }
            if(priorities.find(p => p === candidatures[i].priorite)){
                setCandidaturesValidity(false);
                return;
            }
            priorities.push(candidatures[i].priorite);
        }
        setCandidaturesValidity(true);
    },[candidatures]);

    React.useEffect(() => {
        document.getElementsByTagName('html')[0].scrollTo(0,0);
        console.log("shouldScroll")
    }, [selectedCompany, candidating]);

    //after submit candidature
    async function afterSubmitCandidature(){
        setSelectedCompany(null);
        setCandidating(false);
        getCandidatures();
    }

    function CompanyLine(props){

        console.log("CompanyContainer participation :")
        console.log(props.participation)

        return (
            <CompanyContainer>
                <b onClick={props.onClick}>{props.participation.hsCompany?.properties.name}</b><br/>
                {/* <span className='thin'>{props.participation.participation.data.numTableOULienZoom}</span><br/> */}
                {props.participation.company.logo  && <img alt="" src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + props.participation.company.logo}/>}<br/>
                <p className='thin mini' >{props.participation.participation.data.presentiel === "oui" && (dayjs(props.event.main_date).format('dddd D MMMM YYYY') +" - "+ props.event.localisation)}{props.participation.participation.data.presentiel === "non" && (dayjs(props.event.online_date).format('dddd D MMMM YYYY') +" - "+ (i18n.language === "fr" ? "En ligne" : "Online"))}</p>
                <br/><br/><br/><br/>
                <p className='thin preformatted'>{i18n.language === "fr" ? props.participation.participation.data.description_admin_fr : props.participation.participation.data.description_admin_en}</p><br/>
                <div>
                    <button className='centered' onClick={props.onClick}>{i18n.language === "fr" ? "Plus d'informations" : "More information"}</button>
                </div>
                {props.isNew && <div className='newtag'>{i18n.language === "fr" ? "Nouveau" : "New"}</div>}
            </CompanyContainer>
        )
    }

    const candidaturesToCompanies = candidatures.filter(candidature => participatingCompanies.find((participation) => participation.participation._id === candidature.participationId));
    const companiesCandidatable = participatingCompanies.filter(participation => participation.participation.data?.entreprise_validee).filter(participation => !candidatures.find(c=> c.participationId === participation.participation._id));

    return (
        <div>
            {!selectedCompany && <>
                <Section className='padding'>
                    <span className='linkbutton' onClick={props.onBack}>← {i18n.language === "fr" ? "Retour" : "Back"}</span>
                </Section>
            </>}
            {props.user && props.event ? <>
                {!selectedCompany && <>
                    <Section className='padding'>
                        {candidaturesToCompanies.length > 0 && <>
                            <h1 className='centered'>{i18n.language === "fr" ? "Vos candidatures" : "Your candidatures"}</h1><br/>
                            <p className='thin'>{i18n.language === "fr" ? "Pour les demandes de rendez-vous, merci de bien vouloir indiquer votre ordre de priorité. Vous avez la possibilité de modifier cet ordre et/ou supprimer une demande de rendez-vous jusqu'à la clôture des candidatures. Le comité de sélection prendra en compte vos souhaits, mais nous ne pouvons vous garantir la confirmation de l'ensemble de vos demandes." : "You can change or withdraw a meeting request until the closing date. The selection committee will take your preferences into account, but we cannot guarantee that all your requests will be confirmed."}</p>
                            <br/>
                            <div className='line_cont'>
                                {candidaturesToCompanies.sort((a,b)=>a.priorite - b.priorite).map((candidature,i) =>
                                    <CandidaturePreview participatingCompanies={participatingCompanies} candidature={candidature} allCandidatures={candidatures} key={i} setSelectedCompany={setSelectedCompany} afterUpdateCandidature={() => {getCandidatures();setCandidaturesUpdated(true)}} event={props.event}/>
                                )}
                                {candidaturesValidity ? <>
                                    {candidaturesUpdated && <button className='centered' onClick={() => {setCandidaturesUpdated(false);alert("Données enregistrées")}}>{i18n.language === "fr" ? "Enregistrer" : "Save"}</button>}
                                </>:<>
                                    <b className='centered' style={{color:"red"}}>{i18n.language === "fr" ? "Pour confirmer vos choix, sélectionnez une priorité pour chaque candidature. Les priorités doivent être uniques." : "Incomplete priorities"}</b><br/>
                                    <DisbaledButton className='centered' disbaled >{i18n.language === "fr" ? "Enregistrer" : "Save"}</DisbaledButton>
                                </>}
                            </div>
                        </>}
                        <br/>
                        <h1 className='centered'>{i18n.language === "fr" ? "Liste des sociétés participantes" : "List of participating companies"}</h1><br/>
                        {props.event.type !== "sdo" && <p className='thin'>
                            {i18n.language === "fr" ? "La liste ci-dessous sera complétée de nouveaux noms dans les prochaines semaines. Nous vous recommandons donc de consulter régulièrement cette page pour prendre connaissance des nouveaux noms et mettre à jour vos choix." : "The list below will be updated with additional names in the coming weeks. We therefore recommend that you check this page regularly to see the new names and update your choices."}
                        </p>}
                        <br/>
                        <br/>
                        {participatingCompanies.length > 0 ? <>
                            {companiesCandidatable.filter(p => Date.parse(p.participation.createdAt) >= Date.parse(props.user.previous_last_connection_date)).length > 0 &&
                                <div className='line_cont'>
                                    {companiesCandidatable.sort((a,b) => a.hsCompany?.properties.name.localeCompare(b.hsCompany?.properties.name)).filter(p => Date.parse(p.participation.createdAt) >= Date.parse(props.user.previous_last_connection_date)).map((participation,i) =>
                                        <CompanyLine isNew participation={participation} key={i} event={props.event} onClick={()=>setSelectedCompany(participation)} />
                                    )}
                                </div>
                            }
                            {companiesCandidatable.filter(p => Date.parse(p.participation.createdAt) < Date.parse(props.user.previous_last_connection_date)).length > 0 &&
                                <div className='line_cont'>
                                    {companiesCandidatable.sort((a,b) => a.hsCompany?.properties.name.localeCompare(b.hsCompany?.properties.name)).filter(p => Date.parse(p.participation.createdAt) < Date.parse(props.user.previous_last_connection_date)).map((participation,i) =>
                                        <CompanyLine participation={participation} key={i} event={props.event} onClick={()=>setSelectedCompany(participation)} />
                                    )}
                                </div>
                            }
                        </> : <Spinner/>}
                    </Section>
                </>}
                {selectedCompany && !candidating && <CompanyMoreInformation company={selectedCompany} onBack={()=>setSelectedCompany(null)} showCandidateButton={!candidatures.find(c=> c.participationId === selectedCompany.participation._id)} candidaturesMaxed={candidatures?.length >= 15} onCandidate={()=>{setCandidating(selectedCompany)}} event={props.event} />}
                {candidating && <CandidatureForm company={selectedCompany} user={props.user} allUserData={props.allUserData} onBack={()=>setCandidating(false)} participation={props.participation} afterSubmitCandidature={afterSubmitCandidature} />}
            </> : <Spinner/>}
        </div>
    );
};

export default Candidatures;